import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "pageHeader_text" }
const _hoisted_3 = { style: {"margin-left":"auto"} }
const _hoisted_4 = { class: "logoutBox" }
const _hoisted_5 = ["src"]

import { reactive, computed, ref, watch, Ref, toRefs } from 'vue';
import { useStore } from 'vuex';
import { ImgUrlFix } from '@u/config'
import router, { newRouter } from "@/router";
import { RouteRecordRaw } from "vue-router";
import { geturlbysize } from '@/request/api/fileServer/images';




export default /*@__PURE__*/_defineComponent({
  __name: 'pageHeader',
  props: {
    formData: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props;
// const emit = defineEmits<{

// }>()

const store = useStore();
const lang = store.state.config.lang
const userInfo = computed(() => store.state.userInfo || {})

const state = reactive({
	realName: lang.components.top.userStr,   //用户名
	isShowPersonModal: false,
	headUrl: ''
})
const toIndex = () => {
	router.replace({
		name: 'layout'
	})
}

const getHead = async () => {
	state.headUrl = await geturlbysize({
		data: {
			type: 8,
			objectId: store.state.userInfo.headPhoto
		},
		header: {
			appid: 'br.com'
		}
	})
}

watch(() => store.state.userInfo, () => {
	if (store.state.userInfo) {
		state.realName = store.state.userInfo.realName
		getHead()
	} else {
		state.realName = lang.components.top.userStr
	}
	
}, { immediate: true })

const logout = () => {
	store.commit('setOrganization', '')
	store.commit('setAccessToken', '');
	store.commit('setUserInfo', null);
	store.commit('setRouteList', [])
	store.commit('setMenuList', [])
	localStorage.removeItem('AccessToken')
	const newRouterArr = newRouter.getRoutes().map(item => item.name)
	router.getRoutes().forEach(item => {
		if (newRouterArr.indexOf(item.name) == -1) {
			//@ts-ignore
			router.removeRoute(item.name)
		}
	})
	store.commit('setIsGetInfo', false)
	router.push({ name: 'login' })
}
const showPersonModal = async () => {
	state.isShowPersonModal = true;
}

const {
	realName,
	isShowPersonModal,
	headUrl
} = toRefs(state)

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_header, { class: "pageHeader" }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _unref(ImgUrlFix) + '/images/logo.png',
          onClick: toIndex,
          alt: ""
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(lang).public.title), 1),
          _renderSlot(_ctx.$slots, "title")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_popover, {
            placement: "top-start",
            trigger: "hover",
            content: "this is content, this is content, this is content"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", { src: _unref(headUrl) }, null, 8, _hoisted_5),
                _createElementVNode("span", null, _toDisplayString(userInfo.value.realName), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("ul", { class: "pageHeader_list" }, [
                _createElementVNode("li", null, [
                  _createElementVNode("span", {
                    class: "pointer",
                    onClick: logout
                  }, "退出登录")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", {
                    span: "",
                    class: "pointer",
                    onClick: showPersonModal
                  }, "个人信息")
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 3
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(isShowPersonModal),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(isShowPersonModal) ? (isShowPersonModal).value = $event : null)),
      title: "个人信息"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "80",
          model: _unref(store).state.userInfo
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "realName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(store).state.userInfo.realName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.userInfo.realName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "出生日期",
              prop: "birthday"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(store).state.userInfo.birthday,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).state.userInfo.birthday) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "机构名字",
              prop: "organizationName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(store).state.userInfo.organizationName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).state.userInfo.organizationName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "部门",
              prop: "departmentName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(store).state.userInfo.departmentName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(store).state.userInfo.departmentName) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})